import React from "react";
import Alert from "./Alert";

const TourUsersForm = ({ handleUserFieldChange, handleAddUserRole, userFields, alert }) => {
  return (
    <form onSubmit={handleAddUserRole}>
      <h3 className="form-heading">Add a user</h3>
      <Alert message={alert.message} />
      <div>
        <label>User email</label>
        <input
          type="email"
          name="email"
          value={userFields.email}
          onChange={handleUserFieldChange}
        />
      </div>

      <div>
        <label>User role:</label>
        <select
          name="role"
          value={userFields.role}
          onChange={handleUserFieldChange}
        >
          <option value="owner">owner</option>
          <option value="editor">editor</option>
          <option value="user">viewer</option>
        </select>
      </div>

      <div>
        <button className="form-button" type="submit">
          Add user role
        </button>
      </div>

    </form>
  );
};

export default TourUsersForm;